/**
 * Setup handoffs that may open their task on arrival. Each id names a control that only
 * OPENS a dialog or menu (never sends, saves or deletes); the person confirms inside.
 * Any other cue id just scrolls to and focuses its control.
 */
export const OPENER_CUES = [
  'add-listing',        // My Inventory: Add Listing / Bulk Import choice
  'menu-add-listings',  // Menu detail: Add Listings dialog
  'share-menu',         // Menu detail: Share Menu dialog
  'create-menu',        // My Menus: Create Menu dialog (only when no menu could be made)
  'make-buy-request',   // Buy Requests: Buy Request dialog
  'invite-supplier',    // Supplier Menus: Invite Supplier dialog
] as const;

export function isOpenerCue(id: string): boolean {
  return (OPENER_CUES as readonly string[]).includes(id);
}

/** Reveal a tab-owned opener before the controller looks for its visible control. */
export function setupIntentSearch(path: string, cue: string, search: string): string {
  const params = new URLSearchParams(search);
  if (path === '/buy-requests' && cue === 'make-buy-request') {
    params.set('tab', 'mine');
    params.delete('view');
  }
  return params.toString();
}
